import AxiosPermisos from "../axiosPermisos";

import { path } from "./path";

async function getListProcess(data) {
  return await AxiosPermisos.get(path.list, true, "v2", data);
}

async function getOptions() {
  return await AxiosPermisos.get(path.options, true, "v2");
}

async function createProcess(data) {
  return await AxiosPermisos.post(path.list, true, data, "v2");
}

async function getProcess(id) {
  return await AxiosPermisos.get(path.list+`/${id}`, true, "v2");
}

async function updateProcess(id, data) {
  return await AxiosPermisos.put(path.list+`/${id}`, true, data, "v2");
}

async function getOptionsEvaluation() {
  return await AxiosPermisos.get(path.optionsEvaluation, true, "v2");
}

async function getModifications(data) {
  return await AxiosPermisos.get(path.modifications, true, "v2", data);
}

async function createEvaluation(data) {
  return await AxiosPermisos.post(path.evaluation, true, data, "v2");
}

async function deleteProcess(id) {
  return await AxiosPermisos.delete(path.list+`/${id}`, true, "v2");
}
async function getDownloadProcess(id) {
  return await AxiosPermisos.post(path.list+`/${id}/report-pdf`, true, null, "v2", 'blob');
}

async function getHelpProcess() {
  return await AxiosPermisos.post(path.options+`/user-manual`, true, null, "v2", 'blob');
}

async function getExportProcess(data) {
  return await AxiosPermisos.post(path.list+`/export`, true, data, "v2", 'blob');
}

async function getIndicators(data) {
  return await AxiosPermisos.get(path.indicators, true, "v2", data);
}

async function sendImport(data) {
  return await AxiosPermisos.post(path.list+`/import`, true, data, "v2");
}

async function getPlaintiffs() {
  return await AxiosPermisos.get(path.plaintiffs, true, "v2");
}

async function getListTypeFiles(id) {
  return await AxiosPermisos.get(`${path.listTypeFiles}/${id}/types`, true, "v2");
}

async function getListProcessFiles(id, data) {
  return await AxiosPermisos.get(`${path.listProcessFiles}/${id}/files`, true, "v2", data);
}

async function getHistoryFile(id, type) {
  return await AxiosPermisos.get(`${path.historyFile}/${id}/${type}/history`, true, "v2");
}

async function downloadFile(id) {
  return await AxiosPermisos.get(`${path.downloadFile}/${id}`, true, "v2");
}

async function saveProcessFiles(data) {
  return await AxiosPermisos.postSendFile(
    `${path.saveProcessFiles}`,
    true,
    data,
    "v2"
  );
}

async function deleteFile(id, data) {
  return await AxiosPermisos.delete(`${path.deleteFile}/${id}`, true, "v2", data);
}
export default {
  getProcess,
  getOptions,
  createProcess,
  getListProcess,
  updateProcess,
  getOptionsEvaluation,
  createEvaluation,
  getModifications,
  deleteProcess,
  getDownloadProcess,
  getExportProcess,
  getIndicators,
  sendImport,
  getHelpProcess,
  getPlaintiffs,
  getListTypeFiles,
  getListProcessFiles,
  saveProcessFiles,
  downloadFile,
  deleteFile,
  getHistoryFile,
};
